import DOMPurify from "dompurify";

export const decodeHtmlTextFromString = (text: string): string => {
  const cleanText = DOMPurify.sanitize(text || "");
  const p = document.createElement("p");
  p.innerHTML = cleanText;
  return p.textContent || "";
};

export const nullableDecodeHtmlTextFromString = (text?: string): string | undefined => {
  if (!text) return undefined;
  const cleanText = DOMPurify.sanitize(text || "");
  const p = document.createElement("p");
  p.innerHTML = cleanText;
  return p.textContent || "";
};
